module.exports = __webpack_public_path__ + "img/demo-takeout-400x300.b1e95eaa.jpg";